import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import './styles.css';

const LoadingContainer = styled.div`
  ${({ listLoader }) => listLoader && css`
    flex-direction: row;
    justify-content: flex-start;

    && > p {
      margin: 0;
    }
  `}
`;


const BouncingBallsWrapper = styled.div`
  ${({ listLoader }) => listLoader && css`
    width: 20px;
    height: 20px;
    margin-right: 10px;
  `}
`;

class LoadingIndicator extends Component {
  componentDidMount() {
    const { noScrollLock } = this.props;

    document.body.style.overflow = noScrollLock ? 'visible' : 'hidden';
  }

  componentWillUnmount() {
    document.body.style.overflow = 'visible';
  }
  render() {
    const {
      className, theme, text, listLoader, noScrollLock,
    } = this.props;
    document.body.style.overflow = noScrollLock ? 'visible' : 'hidden';

    return (
      <LoadingContainer listLoader={listLoader} className={`LoadingIndicator ${theme === 'dark' ? 'LoadingIndicator--dark ' : ' '}${className || ''}`}>
        <BouncingBallsWrapper listLoader={listLoader} className="LoadingIndicator__bouncing-balls">
          <div className="LoadingIndicator__ball-1" />
          <div className="LoadingIndicator__ball-2" />
        </BouncingBallsWrapper>
        {
          text &&
          <p className="LoadingIndicator__text">{text}</p>
        }
      </LoadingContainer>
    );
  }
}

LoadingIndicator.propTypes = {
  theme: PropTypes.oneOf(['dark']),
  text: PropTypes.string,
};

export default LoadingIndicator;
